import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-caret-right",
  "use": "tamr-icon-caret-right-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-caret-right\"><path d=\"M23,16a2,2,0,0,1-.6,1.4l-10,10a2,2,0,1,1-2.8-2.8L18.2,16,9.6,7.4a2,2,0,0,1,2.8-2.8l10,10A2,2,0,0,1,23,16Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol